// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1o4M5","footer":"ModalFilter_footer__3l7H_"};